// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
import TurntableController from "./turntable_controller";
import ScrollTransitionController from "./scroll_transition_controller";
import NavbarController from "./navbar_controller";
import LinkController from "./link_controller";
import DatetimeLocalController from "./datetime_local_controller";
import FormChangesController from "./form_changes_controller";
import NestedFormController from "./nested_form_controller";

application.register("hello", HelloController);
application.register("turntable", TurntableController);
application.register("scroll_transition", ScrollTransitionController);
application.register("navbar", NavbarController);
application.register("link", LinkController);
application.register("form-changes", FormChangesController);
application.register("datetime-local", DatetimeLocalController);
application.register("nested-form", NestedFormController);
